<template>
  <InternalNavBar />
  <div class="row" style="height: 10vh;"></div>
  <div class="row" style="justify-content: center">
  <div class="col-6">
    <q-tabs v-model="tab"
            dense
            class="text-black"
            active-color="white"
            indicator-color="white"
            align="center"
            active-bg-color="teal-5"
            style="margin-top: 3vh; font-family: Montserrat;"
            no-caps
    >
      <q-tab name="upcoming" label="Upcoming Sessions" />
      <q-tab name="pending" label="Unaccepted Requests"/>
      <q-tab name="request" label="Request a Session"/>
    </q-tabs>

    <q-tab-panels v-model="tab" animated swipeable>
      <q-tab-panel name="upcoming">
        <p class="text-h4" style="font-family: Montserrat; font-weight: 350"><b>Upcoming</b> sessions</p>
        <div class="row" style="height: 1vh;"></div>
        <q-scroll-area style="height: 70vh">
          <div v-for="(item, n) in acceptedSessions" v-bind:key="n">
            <q-card class="my-card bg-teal-3" flat bordered style="margin-bottom: 2.5vh">
              <q-item>
                <q-item-section avatar>
                  <q-avatar @click="$router.replace('/profile/' + item.sessionTutorUsername)">
                    <img v-bind:src="acceptedSessionsPFPSrcArr[n] === 'blank' ? require(`../assets/blank-avatar.png`) : acceptedSessionsPFPSrcArr[n]">
                  </q-avatar>
                </q-item-section>

                <q-item-section>
                  <div class="row" style="height: 4vh;">
                    <div class="col-3">
                      <q-item-label style="font-family: Lato">Being Tutored By {{item.sessionTutor}}</q-item-label>
                      <q-item-label caption style="font-family: Lato">On {{item.sessionTime}}
                      </q-item-label>
                    </div>

                    <q-separator vertical />

                    <div class="col-8" style="padding-left: 0.5vw">
                      <q-item-label class="text-bold" style="font-family: Lato">{{item.sessionSubjects}}</q-item-label>
                      <q-item-label caption class="text-bold" style="font-family: Lato">
                        {{item.sessionBounty}} Credits
                      </q-item-label>
                    </div>
                  </div>
                </q-item-section>



              </q-item>

              <q-separator />

              <q-card-section horizontal>
                <div class="col-8">
                  <q-card-section>
                    <text style="font-family: Lato; word-break: break-word">{{item.truncatedQuestion}}</text>
                  </q-card-section>
                </div>
                <div class="col-2 q-pa-md text-center">
                  <q-btn v-if="!acceptedCanJoinSession[n]"
                      round
                      color="red-6"
                      icon="cancel"
                      @click="setAcceptedCancelSessionDialog(n)"
                  />
                  <q-btn v-else
                         round
                         color="grey-6"
                         icon="meeting_room"
                         @click="$router.replace('/session/' + item.sessionURL)"
                  />
                  <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato" v-if="!acceptedCanJoinSession[n]">
                    Cancel Session
                  </q-item-label>
                  <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato" v-else>
                    Join Session
                  </q-item-label>
                </div>
                <div class="col-2 q-pa-md text-center">
                  <q-btn
                      round
                      color="deep-orange-10"
                      icon="assignment"
                      @click="setAcceptedMoreInfoDialog(n)"
                  />
                  <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato;">
                    More Info
                  </q-item-label>
                </div>
              </q-card-section>
            </q-card>

          <q-dialog v-model="acceptedMoreInfoDialog[n]" no-esc-dismiss no-backdrop-dismiss>
            <q-card flat bordered style="width: 40vw">
              <q-card-section>
                <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Session Info</div>
              </q-card-section>
              <q-separator />
              <q-card-section style="padding-top: 0.5vh">
                <p class="text-caption text-teal-10 " style="font-family: Lato; word-wrap: break-word"><b>Question</b>: <text class="text-black">{{item.sessionQuestion}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Date</b>: <text class="text-black">{{item.sessionTime.substr(0, 12)}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Time</b>: <text class="text-black">{{item.sessionTime.substr(12)}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Subjects</b>: <text class="text-black">{{item.sessionSubjects}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Bounty</b>: <text class="text-black">{{item.sessionBounty}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Tutor</b>: <text class="text-black">{{item.sessionTutor}}</text></p>

              </q-card-section>

              <q-separator />

              <q-card-actions align="right">
                <q-btn flat label="Got the info, thanks!" color="red-10" v-close-popup style="font-family: Lato" no-caps/>

              </q-card-actions>
            </q-card>
          </q-dialog>

          <q-dialog v-model="acceptedCancelSessionDialog[n]" no-esc-dismiss no-backdrop-dismiss>
            <q-card flat bordered style="width: 40vw">
              <q-card-section>
                <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Cancel Session</div>
              </q-card-section>
              <q-separator />
              <q-card-section style="padding-top: 0.5vh">
                <p class="text-caption text-teal-10 " style="font-family: Lato; word-wrap: break-word">You are about to cancel the tutoring session. You cannot reverse this action. Your credits spent on the bounty will be refunded.</p>
              </q-card-section>

              <q-separator />

              <q-card-actions align="right">
                <q-btn push label="Yes, Cancel Session" color="red-6" @click="acceptedCancelSession(n)" style="font-family: Lato" no-caps />
                <q-btn flat label="No, Go Back!" color="red-10" v-close-popup style="font-family: Lato" no-caps/>

              </q-card-actions>
            </q-card>
          </q-dialog>
          </div>

        </q-scroll-area>
      </q-tab-panel>
      <q-tab-panel name="pending">
        <p class="text-h4" style="font-family: Montserrat; font-weight: 350"><b>Unaccepted</b> requests</p>
        <div class="row" style="height: 1vh;"></div>
        <q-scroll-area style="height: 70vh">
          <div v-for="(item, i) in unAcceptedSessions" v-bind:key="i">
            <q-card class="my-card bg-teal-3" flat bordered style="margin-bottom: 2.5vh">
              <q-item>
                <q-item-section avatar>
                  <q-avatar @click="$router.replace('/profile/' + item.sessionCreatorUsername)">
                    <img v-bind:src="unAcceptedSessionsPFPSrcArr[i] === 'blank' ? require(`../assets/blank-avatar.png`) : unAcceptedSessionsPFPSrcArr[i]">
                  </q-avatar>
                </q-item-section>

                <q-item-section>
                  <div class="row" style="height: 4vh;">
                    <div class="col-3">
                      <q-item-label style="font-family: Lato">{{item.sessionCreator}}</q-item-label>
                      <q-item-label caption style="font-family: Lato">On {{item.sessionTime}}
                      </q-item-label>
                    </div>

                    <q-separator vertical />

                    <div class="col-8" style="padding-left: 0.5vw">
                      <q-item-label class="text-bold" style="font-family: Lato">{{item.sessionSubjects}}</q-item-label>
                      <q-item-label caption class="text-bold" style="font-family: Lato">
                        {{item.sessionBounty}} Credits
                      </q-item-label>
                    </div>
                  </div>
                </q-item-section>



              </q-item>

              <q-separator />

              <q-card-section horizontal>
                <div class="col-8">
                  <q-card-section>
                    <text style="font-family: Lato; word-break: break-word">{{item.truncatedQuestion}}</text>
                  </q-card-section>
                </div>
                <div class="col-2 q-pa-md text-center">
                  <q-btn
                      round
                      color="red-6"
                      icon="cancel"
                      @click="setUnAcceptedCancelSessionDialog(i)"
                  />
                  <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato">
                    Cancel Session
                  </q-item-label>
                </div>
                <div class="col-2 q-pa-md text-center">
                  <q-btn
                      round
                      color="deep-orange-10"
                      icon="assignment"
                      @click="setUnAcceptedMoreInfoDialog(i)"
                  />
                  <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato;">
                    More Info
                  </q-item-label>
                </div>
              </q-card-section>
            </q-card>

          <q-dialog v-model="unAcceptedMoreInfoDialog[i]" no-esc-dismiss no-backdrop-dismiss>
            <q-card flat bordered style="width: 40vw">
              <q-card-section>
                <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Session Info</div>
              </q-card-section>
              <q-separator />
              <q-card-section style="padding-top: 0.5vh">
                <p class="text-caption text-teal-10 " style="font-family: Lato; word-wrap: break-word"><b>Question</b>: <text class="text-black">{{item.sessionQuestion}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Date</b>: <text class="text-black">{{item.sessionTime.substr(0, 12)}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Time</b>: <text class="text-black">{{item.sessionTime.substr(12)}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Subjects</b>: <text class="text-black">{{item.sessionSubjects}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Bounty</b>: <text class="text-black">{{item.sessionBounty}}</text></p>

              </q-card-section>

              <q-separator />

              <q-card-actions align="right">
                <q-btn flat label="Got the info, thanks!" color="red-10" v-close-popup style="font-family: Lato" no-caps/>

              </q-card-actions>
            </q-card>
          </q-dialog>

          <q-dialog v-model="unAcceptedCancelSessionDialog[i]" no-esc-dismiss no-backdrop-dismiss>
            <q-card flat bordered style="width: 40vw">
              <q-card-section>
                <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Cancel Session</div>
              </q-card-section>
              <q-separator />
              <q-card-section style="padding-top: 0.5vh">
                <p class="text-caption text-teal-10 " style="font-family: Lato; word-wrap: break-word">You are about to cancel the tutoring session. You cannot reverse this action. Your credits spent on the bounty will be refunded.</p>
              </q-card-section>

              <q-separator />

              <q-card-actions align="right">
                <q-btn push label="Yes, Cancel Session" color="red-6" @click="unAcceptedCancelSession(i)" style="font-family: Lato" no-caps />
                <q-btn flat label="No, Go Back!" color="red-10" v-close-popup style="font-family: Lato" no-caps/>

              </q-card-actions>
            </q-card>
          </q-dialog>

          </div>
        </q-scroll-area>
      </q-tab-panel>

      <q-tab-panel name="request">
        <p class="text-h4" style="font-family: Montserrat; font-weight: 350"><b>Request</b> a session</p>
        <p class="text-h6" style="font-family: Lato; font-weight: 350"><b>Credits Available</b>: {{availableCredits}}</p>
        <div class="row" style="height: 1vh;"></div>

        <q-form @submit="submitRequest">
        <p class="text-black" style="font-family: Lato; margin-bottom: 0px; font-size: 14px;">What is your question?</p>
        <q-input color="teal-10" bg-color="white" outlined v-model="questionText" label="Enter your question" label-color="teal-10" style="font-family: Lato;" type="textarea" :rules="[val => val.length >= 200 || 'Please use at least 200 characters!',
                                                     val => val.length <= 2000 || 'Please use less than 2000 characters']">
        </q-input>

        <p class="text-black" style="font-family: Lato; margin-top: 1vh; margin-bottom: 0px; font-size: 14px;">What subject does your question apply to?</p>
        <q-select
            v-model="firstSubject"
            use-input
            input-debounce="0"
            label="First Subject"
            :options="options.filter(x => !subjectsTaken.has(x))"
            @filter="filterFn"
            style="font-family: Lato"
            color="teal-10"
            :rules="[val => val != null || 'Please select a subject']"
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey">
                No subjects
              </q-item-section>
            </q-item>
          </template>
        </q-select>

        <p class="text-black" style="font-family: Lato; margin-top: 1vh; margin-bottom: 0px; font-size: 14px;">Add up to two optional but relevant subjects.</p>

        <q-select
            v-model="secondSubject"
            clearable
            use-input
            input-debounce="0"
            label="Second Subject"
            :options="options.filter(x => !subjectsTaken.has(x))"
            @filter="filterFn"
            style="font-family: Lato"
            color="teal-10"
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey">
                No subjects
              </q-item-section>
            </q-item>
          </template>
        </q-select>

        <q-select
            v-model="thirdSubject"
            clearable
            use-input
            input-debounce="0"
            label="Third Subject"
            :options="options.filter(x => !subjectsTaken.has(x))"
            @filter="filterFn"
            style="font-family: Lato"
            color="teal-10"
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey">
                No subjects
              </q-item-section>
            </q-item>
          </template>
        </q-select>

        <p class="text-black" style="font-family: Lato; margin-top: 2vh; margin-bottom: 3vh; font-size: 14px;">Request Bounty (more credits may lead to higher chances of request acceptance)</p>
        <q-slider
            v-model="bounty"
            :min="10"
            :max="100"
            :step="1"
            snap
            label
            label-always
            color="teal-10"
        />

        <p class="text-black" style="font-family: Lato; margin-top: 1vh; margin-bottom: 0vh; font-size: 14px;">Session Time (please make sure you are ready to attend)</p>

        <div class="row justify-center">
          <q-date v-model="sessionDate" color="teal-10" style="margin-top: 1vh; margin-right: 5vw;"/>
          <q-time v-model="sessionTime" color="teal-10" style="margin-top: 1vh" :minute-options="[0, 15, 30, 45]"/>
        </div>
        <q-btn no-caps push label="Submit Request" style="background-color: #A8D0E6; border-radius: 20px; width: 12vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-top: 2vh;" type="submit" label-color="grey-7"   />
        </q-form>

        <q-dialog v-model="confirmationDialog" no-esc-dismiss no-backdrop-dismiss>
          <q-card flat bordered style="width: 40vw">
              <q-card-section>
                <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Session Confirmation</div>
              </q-card-section>
              <q-separator />
              <q-card-section style="padding-top: 0.5vh">
                <div class="text-body1" style="font-family: Lato; margin-bottom: 1vh">Does this look correct? <text class="text-bold text-red-10">You won't be able to change this later!</text></div>
                <p class="text-caption text-teal-10 " style="font-family: Lato; word-wrap: break-word"><b>Question</b>: <text class="text-black">{{questionText}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Date</b>: <text class="text-black">{{sessionDate}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Time</b>: <text class="text-black">{{sessionTime}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Primary Subject</b>: <text class="text-black">{{firstSubject}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato" v-if="secondSubject != null && thirdSubject != null"><b>Other Subjects</b>: <text class="text-black">{{secondSubject + ", " + thirdSubject}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato" v-else-if="secondSubject != null && thirdSubject == null"><b>Other Subjects</b>: <text class="text-black">{{secondSubject}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato" v-else-if="secondSubject == null && thirdSubject != null"><b>Other Subjects</b>: <text class="text-black">{{thirdSubject}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Bounty</b>: <text class="text-black">{{bounty}}</text></p>

              </q-card-section>

            <q-separator />

            <q-card-actions align="right">
              <q-btn flat label="No, Go Back" color="red-10" v-close-popup style="font-family: Lato" no-caps/>
              <q-btn push label="Yes, Schedule Session" color="teal-10" @click="scheduleRequest" style="font-family: Lato" no-caps />

            </q-card-actions>
          </q-card>
        </q-dialog>

      </q-tab-panel>

    </q-tab-panels>




  </div>
</div>

</template>

<script>
  import {getCurrentInstance, ref} from 'vue'
  import { date } from 'quasar'
  import InternalNavBar from "@/components/internal-navbar";
  import { Dialog } from 'quasar'
  import firebase from "firebase";
  import 'datejs';

  const constOptions = ["Accounting", "Business law", "Business management", "Consumer education", "Entrepreneurial skills", "Introduction to business", "Marketing ", "Personal finance", "Animation", "App development", "Audio production", "Computer programming", "Computer repair", "Film production", "Graphic design", "Keyboarding", "Media technology", "Music production", "Video game development", "Web design", "Web programming", "Word processing ", "AP Computer Science A", "AP Computer Science Principles", "American literature", "British literature", "Contemporary literature", "Creative writing", "Communication skills", "Debate", "English language and composition", "English literature and composition", "Humanities", "Journalism", "Literary analysis", "Modern literature", "Poetry", "Popular literature", "Rhetoric", "Shakespeare", "Technical writing", "World literature", "Written and oral communication", "AP English Language and Composition", "AP English Literature and Composition", "Chemistry of foods", "CPR training", "Culinary arts", "Early childhood development", "Early childhood education", "Family studies", "Fashion and retail merchandising", "Fashion construction", "Home economics", "Interior design", "Nutrition", "American Sign Language", "Ancient Greek", "Arabic", "Chinese", "French", "German", "Hebrew", "Italian", "Japanese", "Korean", "Latin", "Portuguese", "Russian", "Spanish", "AP Chinese Language and Culture", "AP French Language and Culture", "AP German Language and Culture", "AP Italian Language and Culture", "AP Japanese Language and Culture", "AP Latin", "AP Spanish Language and Culture", "AP Spanish Literature and Culture", "Algebra 1", "Algebra 2", "Calculus", "Computer math", "Consumer math", "Fundamentals of math", "Geometry", "Integrated math", "Math applications", "Multivariable calculus", "Practical math", "Pre-algebra", "Pre-calculus", "Probability", "Quantitative literacy", "Statistics", "Trigonometry", "AP Calculus AB", "AP Calculus BC", "AP Statistics", "Choir", "Concert band", "Dance", "Drama", "Guitar", "Jazz band", "Marching band", "Music theory", "Orchestra", "Percussion", "Piano ", "Theater technology", "World music", "Aerobics", "Dance", "Gymnastics", "Health", "Lifeguard training", "Pilates", "Racket sports", "Specialized sports", "Swimming", "Weight training", "Yoga", "Agriculture", "Astronomy", "Biology", "Botany", "Chemistry", "Earth science", "Electronics", "Environmental science", "Environmental studies", "Forensic science", "Geology", "Marine biology", "Oceanography", "Physical science", "Physics", "Zoology", "AP Biology", "AP Chemistry", "AP Environmental Science", "AP Physics C: Electricity and Magnetism", "AP Physics C: Mechanics", "AP Physics 1: Algebra-Based", "AP Physics 2: Algebra-Based", "Cultural anthropology", "Current events", "European history", "Geography", "Global studies", "Human geography", "International relations", "Law", "Macroeconomics", "Microeconomics", "Modern world studies", "Physical anthropology", "Political studies", "Psychology", "Religious studies", "Sociology", "US government", "US history", "Women’s studies", "World history", "World politics", "World religions", "AP Comparative Government and Politics", "AP European History", "AP Human Geography", "AP Macroeconomics", "AP Microeconomics", "AP Psychology", "AP United States Government and Politics", "AP United States History", "AP World History", "3-D art", "Art history", "Ceramics", "Digital media", "Drawing", "Film production", "Jewelry design", "Painting", "Photography", "Printmaking", "Sculpture", "AP Art History", "AP Music Theory", "AP Studio Art: 2-D Design", "AP Studio Art: 3-D Design", "AP Studio Art: Drawing", "Auto body repair", "Auto mechanics", "Building construction", "Computer-aided drafting", "Cosmetology", "Criminal justice", "Driver education", "Electronics", "FFA", "Fire science", "Heating and cooling systems", "Hospitality and tourism", "JROTC", "Metalworking", "Networking", "Plumbing", "Production technology", "Refrigeration fundamentals", "Robotics", "Woodworking"]
  export default {
    name: "Name",
    components: {
      InternalNavBar,
    },
    setup () {
      const internalInstance = getCurrentInstance()

      var options = ref(constOptions)
      var sessionDate = ref(date.formatDate(Date.now(), 'YYYY/MM/DD'))
      var sessionTime = ref(date.formatDate(Date.now(), 'HH:mm'))
      var confirmationDialog = ref(false)
      var availableCredits = ref(0)

      var acceptedSessions = ref([])
      var acceptedSessionsPFPSrcArr = ref([])
      var acceptedMoreInfoDialog = ref([])
      var acceptedCancelSessionDialog = ref([])
      var acceptedCanJoinSession = ref([])

      var unAcceptedSessions = ref([])
      var unAcceptedSessionsPFPSrcArr = ref([])
      var unAcceptedMoreInfoDialog = ref([])
      var unAcceptedCancelSessionDialog = ref([])

      var firstSubject = ref(null)
      var secondSubject = ref(null)
      var thirdSubject = ref(null)

      var subjectsTaken = new Set([firstSubject, secondSubject, thirdSubject])



      return {
        // fixed: ref(false),
        // date: ref('2019-02-01 12:44')
        tab: ref('request'),
        questionText: ref(''),
        bounty: ref(55),
        sessionDate,
        sessionTime,
        options,
        confirmationDialog,
        internalInstance,
        availableCredits,
        firstSubject,
        secondSubject,
        thirdSubject,
        subjectsTaken,
        acceptedSessions,
        acceptedSessionsPFPSrcArr,
        acceptedMoreInfoDialog,
        acceptedCancelSessionDialog,
        unAcceptedSessions,
        unAcceptedSessionsPFPSrcArr,
        unAcceptedMoreInfoDialog,
        unAcceptedCancelSessionDialog,
        acceptedCanJoinSession,
        filterFn (val, update) {
          if (val === '') {
            update(() => {
              options.value = constOptions

              // here you have access to "ref" which
              // is the Vue reference of the QSelect
            })
            return
          }

          update(() => {
            const needle = val.toLowerCase()
            options.value = constOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
          })
        },

      }
  },
  methods: {
    async submitRequest () {
      if (this.sessionTime == null) {
        Dialog.create({
          title: 'An error occurred',
          message: "Please enter a valid time for the session.",
          persistent: true
        }).onOk(() => {
          // console.log('OK')
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
        return
      }

      if (this.sessionDate == null) {
        Dialog.create({
          title: 'An error occurred',
          message: "Please enter a valid date for the session.",
          persistent: true
        }).onOk(() => {
          // console.log('OK')
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
        return
      }

      var now = new Date()
      var dateTimeString = this.sessionDate + ' ' + this.sessionTime
      if (Date.parse(now) > Date.parse(dateTimeString)) {
        Dialog.create({
          title: 'An error occurred',
          message: "Please choose a time in the future.",
          persistent: true
        }).onOk(() => {
          // console.log('OK')
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
        return
      }

      if (this.bounty > this.availableCredits) {
        Dialog.create({
          title: 'Credit Overdraft Warning',
          message: "You do not have enough credits to process this bounty. You have " + this.availableCredits + " credits, but the bounty you chose is of " + this.bounty + " credits. Please choose a bounty that fits in your budget, then try again. If you need more credits, visit the shop or tutor others.",
          persistent: true
        }).onOk(() => {
          // console.log('OK')
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
        return
      }

      if (this.secondSubject == null && this.thirdSubject != null) {
        if (this.thirdSubject === this.firstSubject) {
          Dialog.create({
            title: 'Duplicate Subjects',
            message: "Please choose different subjects.",
            persistent: true
          }).onOk(() => {
            // console.log('OK')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
          return
        }
      }
      if (this.secondSubject != null && this.thirdSubject == null) {
        if (this.secondSubject === this.firstSubject) {
          Dialog.create({
            title: 'Duplicate Subjects',
            message: "Please choose different subjects.",
            persistent: true
          }).onOk(() => {
            // console.log('OK')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
          return
        }
      }
      if (this.secondSubject != null && this.thirdSubject != null) {
        if (this.secondSubject === this.thirdSubject || this.secondSubject === this.firstSubject || this.thirdSubject === this.firstSubject) {
          Dialog.create({
            title: 'Duplicate Subjects',
            message: "Please choose different subjects.",
            persistent: true
          }).onOk(() => {
            // console.log('OK')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
          return
        }
      }

      this.confirmationDialog = true
    },
    async scheduleRequest() {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL

      await firebase.auth().onAuthStateChanged(async (user) => {
        let IDToken = await user.getIdToken(true)
        let subjectsArr = [this.firstSubject]

        if (this.secondSubject != null)
          subjectsArr.push(this.secondSubject)
        if (this.thirdSubject != null)
          subjectsArr.push(this.thirdSubject)

        const constdate = new Date()
        let sessionTimeString = this.sessionDate.replaceAll("/", "-") + " " + this.sessionTime
        var time = new Date(sessionTimeString).getTime()
        var offset = constdate.getTimezoneOffset() * 60000
        sessionTimeString = date.formatDate(new Date(offset + time), "YYYY-MM-DD HH:mm")

        let response = await fetch(url + '/addNewSession', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: IDToken,
            sessionScheduleTime: sessionTimeString,
            question: this.questionText,
            subjects: subjectsArr,
            bounty: this.bounty
          })
        })
        let result = await response.json()
        if (result.code !== 'SUCCESSFUL') {
          Dialog.create({
            title: 'An error occurred',
            message: "An error occurred. Your session was not created. Please try again. \nError: " + result.code.toString(),
            persistent: true
          }).onOk(() => {
            // console.log('OK')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
          return
        } else {
          await Dialog.create({
            title: 'Session Created',
            message: "Your session was created successfully. You will now be redirected to the profile page.",
            persistent: true
          }).onOk(() => {
            this.$router.replace('/profile')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
          return
        }
      })
    },
    setAcceptedMoreInfoDialog(i) {
      this.acceptedMoreInfoDialog[i] = true
    },
    setAcceptedCancelSessionDialog(i) {
      this.acceptedCancelSessionDialog[i] = true
    },
    setUnAcceptedMoreInfoDialog(i) {
      this.unAcceptedMoreInfoDialog[i] = true
    },
    setUnAcceptedCancelSessionDialog(i) {
      this.unAcceptedCancelSessionDialog[i] = true
    },
    async acceptedCancelSession(i) {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL
      await firebase.auth().onAuthStateChanged(async (user) => {
        let IDToken = await user.getIdToken(true)
        let response = await fetch(url + '/cancelSession', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: IDToken,
            sessionID: this.acceptedSessions[i]._id
          })
        })
        let result = await response.json()
        if (result.code !== 'SUCCESSFUL') {
          Dialog.create({
            title: 'Session Not Cancelled',
            message: "An error occurred. Please try again. \nError: " + result.code.toString(),
            persistent: true
          }).onOk(() => {
            // console.log('OK')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
        } else {
          Dialog.create({
            title: 'Session Cancelled',
            message: "The session has been cancelled.",
            persistent: true
          }).onOk(() => {
            // console.log('OK')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
        }
        this.acceptedCancelSessionDialog[i] = false
      })
    },
    async unAcceptedCancelSession(i) {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL
      await firebase.auth().onAuthStateChanged(async (user) => {
        let IDToken = await user.getIdToken(true)
        let response = await fetch(url + '/cancelSession', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: IDToken,
            sessionID: this.unAcceptedSessions[i]._id
          })
        })
        let result = await response.json()
        if (result.code !== 'SUCCESSFUL') {
          Dialog.create({
            title: 'Session Not Cancelled',
            message: "An error occurred. Please try again. \nError: " + result.code.toString(),
            persistent: true
          }).onOk(() => {
            // console.log('OK')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
        } else {
          Dialog.create({
            title: 'Session Cancelled',
            message: "The session has been cancelled.",
            persistent: true
          }).onOk(() => {
            // console.log('OK')
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
        }
        this.unAcceptedCancelSessionDialog[i] = false
      })
    }
  },
  async mounted() {
    let url = this.internalInstance.appContext.config.globalProperties.$backendURL

    await firebase.auth().onAuthStateChanged(async (user) => {
      let IDToken = await user.getIdToken(true)
      let response = await fetch(url + '/getUserProfileDataUID', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: IDToken
        })
      })
      let result = await response.json()
      this.availableCredits = result.profileData.credits



      response = await fetch(url + '/getUserAcceptedSessions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: IDToken,
        })
      })
      result = await response.json()

      this.acceptedSessions = result.sessions

      for (let i = 0; i < this.acceptedSessions.length; i++) {
        this.acceptedMoreInfoDialog.push(false)
        this.acceptedCancelSessionDialog.push(false)

        let subjectsString = ""
        let sessionSubjects = this.acceptedSessions[i].sessionSubjects
        for (let j = 0; j < sessionSubjects.length; j++) {
          subjectsString = subjectsString + sessionSubjects[j].toString() + ", "
        }
        subjectsString = subjectsString.substr(0, subjectsString.length - 2)
        this.acceptedSessions[i].sessionSubjects = subjectsString

        this.acceptedSessions[i].truncatedQuestion = this.acceptedSessions[i].sessionQuestion.substr(0, 240)
        if (this.acceptedSessions[i].sessionQuestion.length > 240) {
          this.acceptedSessions[i].truncatedQuestion = this.acceptedSessions[i].truncatedQuestion + "..."
        }

        const constdate = new Date()
        let time = new Date(this.acceptedSessions[i].sessionTime).getTime()
        let offset = constdate.getTimezoneOffset() * 60000
        let newDate = new Date(time - offset)
        this.acceptedSessions[i].sessionTime = Date.parse(newDate).toString("MMM dd, yyyy HH:mm")

        this.acceptedCanJoinSession[i] = newDate.getTime() - constdate.getTime() <= 86400000



        let response = await fetch(url + '/getPFP', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username: this.acceptedSessions[i].sessionTutorUsername
          })
        })
        let result = await response.json()
        this.acceptedSessionsPFPSrcArr[i] = result.image == null ? "blank" : "data:image/png;base64," + result.image
      }



      response = await fetch(url + '/getUserUnAcceptedSessions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: IDToken,
        })
      })
      result = await response.json()

      this.unAcceptedSessions = result.sessions

      for (let i = 0; i < this.unAcceptedSessions.length; i++) {
        this.unAcceptedMoreInfoDialog.push(false)
        this.unAcceptedCancelSessionDialog.push(false)

        let subjectsString = ""
        let sessionSubjects = this.unAcceptedSessions[i].sessionSubjects
        for (let j = 0; j < sessionSubjects.length; j++) {
          subjectsString = subjectsString + sessionSubjects[j].toString() + ", "
        }
        subjectsString = subjectsString.substr(0, subjectsString.length - 2)
        this.unAcceptedSessions[i].sessionSubjects = subjectsString

        this.unAcceptedSessions[i].truncatedQuestion = this.unAcceptedSessions[i].sessionQuestion.substr(0, 240)
        if (this.unAcceptedSessions[i].sessionQuestion.length > 240) {
          this.unAcceptedSessions[i].truncatedQuestion = this.unAcceptedSessions[i].truncatedQuestion + "..."
        }

        const constdate = new Date()
        let time = new Date(this.unAcceptedSessions[i].sessionTime).getTime()
        let offset = constdate.getTimezoneOffset() * 60000
        let newDate = new Date(time - offset)
        this.unAcceptedSessions[i].sessionTime = Date.parse(newDate).toString("MMM dd, yyyy HH:mm")



        let response = await fetch(url + '/getPFP', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username: this.unAcceptedSessions[i].sessionCreatorUsername
          })
        })
        let result = await response.json()
        this.unAcceptedSessionsPFPSrcArr[i] = result.image == null ? "blank" : "data:image/png;base64," + result.image
      }

    })
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200;300;400;500;600;700;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Gentium+Basic:ital,wght@0,400;0,700;1,400;1,700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
@font-face {
  font-family: "Farray";
  src: url("../assets/fonts/FARRAY.otf");
}

.text-caption {
  margin-bottom: 0vh;
}

</style>

